import * as React from "react";

function SvgIconCloseCircle(props) {
  return <svg viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M11 .5C16.798.5 21.5 5.202 21.5 11S16.798 21.5 11 21.5.5 16.798.5 11 5.202.5 11 .5zm0 1.9a8.6 8.6 0 10.001 17.201A8.6 8.6 0 0011 2.4zM8.879 7.464l2.151 2.152 2.091-2.09a1 1 0 011.415 1.414l-2.092 2.09 2.092 2.091a1 1 0 01-1.415 1.415l-2.091-2.092-2.151 2.153a1 1 0 11-1.415-1.414l2.152-2.153-2.152-2.151A1 1 0 018.88 7.464z" fill="currentColor" fillRule="evenodd" /></svg>;
}

export default SvgIconCloseCircle;